import React from 'react';
import styled from 'styled-components';
import { NavLink as RouterNavLink } from 'react-router-dom';


export const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const SideNavigation = styled.nav`
  width: 240px; /* 네비게이션 바의 고정 너비 */
  background-color: #f2f2f2;
  padding: 5px;
  border-left: 1px solid #dee2e6;
  flex-shrink: 0; /* 사이드 네비게이션이 고정된 너비를 유지하도록 설정 */
`;

export const MainContent = styled.main`
  flex-grow: 1; /* 메인 컨텐츠가 가능한 많은 공간을 차지 */
  padding: 20px;
  overflow-y: auto;
`;

export const SectionContainer = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SectionHeading = styled.h3`
  margin: 5px 0;
  font-size: 18px;
  font-weight: bold;
  color: #343a40;
  padding: 4px 5px;
  background-color: #e9ecef;
  border-bottom: 1px solid #dee2e6;
`;

export const SubNavContainer = styled.nav`
  background-color: #f8f9fa;
  padding: 16px 0;
  width: 100%;
  box-sizing: border-box;
`;

export const SubNavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SubNavItem = styled.li`
  margin: 4px 0;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const SubNavLink = styled(RouterNavLink)`
  font-size: 15px;
  font-weight: 500;
  color: #495057;
  text-decoration: none;
  padding: 8px 20px;
  display: block;
  transition: all 0.2s ease;
  border-left: 4px solid transparent;

  &.active {
    color: #007bff;
    font-weight: 600;
    background-color: #e9ecef;
    border-left-color: #007bff;
  }

  &:hover {
    background-color: #e9ecef;
    color: #007bff;
  }
`;

export default function SubNavigator({ links }) {
  return (
    <SubNavContainer>
      <SubNavList>
        {links.map((link, index) => (
          <SubNavItem key={index}>
            <SubNavLink to={link.path}>
              {link.label}
            </SubNavLink>
          </SubNavItem>
        ))}
      </SubNavList>
    </SubNavContainer>
  );
}
